import { usePathname } from "next/navigation";
import GhostButton from "~/designSystem/components/Buttons/GhostButton";

import { routes } from "~/core/constants/routes";
import { useSignout } from "~/core/hooks/use-signout";
import If from "~/core/ui/If";

const SubscriptionFooter = () => {
  const { signout } = useSignout();
  const pathname = usePathname();

  return (
    <div className="flex flex-col gap-2 items-center">
      <p className="flex items-start justify-center gap-0.5 text-center text-xs leading-snug text-black opacity-70">
        <span className="mt-[1px] text-sm font-semibold">*</span>
        <span>
          Founding 1000 rate of{" "}
          <span className="font-medium opacity-90">$200/month</span> locked for
          1 year. Discounted renewal rate applies after.
        </span>
      </p>

      <If condition={pathname !== routes.auth.onboarding}>
        <GhostButton
          label="Logout"
          onClick={() => {
            signout();
          }}
        />
      </If>
    </div>
  );
};

export default SubscriptionFooter;
